// extracted by mini-css-extract-plugin
export default {"container":"z2BPF","tabPanel":"lxPEu controls","option":"Mj0Uq","icon":"ui9Oq","main":"RdV8M","wrapper":"vjyue","canvas":"Bqi0j","controls":"qJLq9","separator":"InhqZ"};